/**
 * @file Map palette tokens for markers, clusters, routes, and info windows.
 * Marker/cluster/route colors feed Google Maps JS options (literal hex
 * required) — pick `mapTokens` vs `mapTokensDark` by color scheme. InfoWindow
 * values style DOM content, where the var()-backed shadow resolves normally.
 */
import { coral, teal, sand } from './colors';
import { shadows } from './shadows';

export const mapTokens = {
  marker: {
    default: coral[6],
    selected: coral[7],
    visited: teal[6]
  },
  cluster: {
    small: sand[5],
    medium: coral[6],
    large: coral[8]
  },
  route: {
    primary: coral[6],
    alt: teal[6],
    hidden: '#94A3B8'
  },
  infoWindow: {
    bg: '#F4F2EC',
    text: '#111827',
    textSecondary: '#3B4A5E',
    border: '#E4E0D6',
    radius: '16px',
    shadow: shadows.popover
  }
};

// Brand anchors shift to lighter shades (6 → 4/5) for contrast on dark tiles.
export const mapTokensDark = {
  marker: {
    default: coral[4],
    selected: coral[5],
    visited: teal[4]
  },
  cluster: {
    small: sand[4],
    medium: coral[5],
    large: coral[7]
  },
  route: {
    primary: coral[4],
    alt: teal[4],
    hidden: '#6B6459'
  },
  infoWindow: {
    bg: '#23201B',
    text: '#FAFAF8',
    textSecondary: '#C9C2B8',
    border: 'rgba(250,245,235,0.12)',
    radius: '16px',
    shadow: shadows.popover
  }
};
